export default __webpack_public_path__ + "static/media/HariBhoomi.63c5dcbf.jpeg";